import { create } from "zustand";

type MessageStore = {
  messages: string[];
  addMessage: (message: string) => void;
  removeMessage: (index: number) => void;
  clear: () => void;
};

const useMessageStore = create<MessageStore>((set) => ({
  messages: [],
  addMessage: (message) =>
    set((state) => ({ messages: [...state.messages, message] })),
  removeMessage: (index) =>
    set((state) => ({
      messages: state.messages.filter((_, i) => i !== index),
    })),
  clear: () => set({ messages: [] }),
}));

export default useMessageStore;
